import {Ability} from '~/lib/ability';
import {IPreTargetingConfig} from '~/modules/Bidders/models/PreTargeting';

export class AppAdsAbility extends Ability {
    canEdit = () => this.isAdmin();
    canCopy = () => this.isAdmin() || this.isSeller() || this.isSelfServe();
    canDownload = () => this.isAdmin() || this.isSeller() || this.isSelfServe();
    canViewAppAds = () => this.isAdmin();
    canViewSellerAppAds = () => this.isSeller() || this.isSelfServe();
    canViewDownloadHistory = () => this.isAdmin();
    canViewMissingLines = () => this.isAdmin() || this.isSeller() || this.isSelfServe();
    canViewMismatchedLines = () => this.isAdmin() || this.isSeller() || this.isSelfServe();
}

